import React from 'react'
import { avatarColors } from '../../../mockups/Profile/profile_data'
import { MdRemoveRedEye } from "react-icons/md";
import { GoHeartFill } from "react-icons/go";
import { Link } from 'react-router-dom';
import { FiPlus } from "react-icons/fi";

function MainProjectFeed() {


  return (
    <div className='bg-[#101010] py-6 px-4 sm:px-8'>
        <div>
        <div className='flex justify-between mt-4 mb-[60px]'>
        <p className='text-xl font-semibold'>My Projects</p>
        <Link to="/project/new" className='font-semibold md:mr-4'>
        <FiPlus className='inline mr-2' />Create New
        </Link>
      </div>

    <div className='flex flex-col lg:flex-row lg:flex-wrap lg:justify-between h-[200vh] lg:h-screen pr-5
    overflow-y-scroll scroll-bar-in-dark'>
        {avatarColors.map((item,idx) => {
            return (
        <div className='w-full lg:w-[45%] my-12' key={idx}>
        
        <Link to={`project_id-${item.slice(1)}/${idx}`}>
        <div 
        style={{backgroundColor : item}}
        className={`h-[230px] w-full rounded-xl`}  />

        <div className='py-5'>
            <p className='text-xl font-semibold'>Solar Panels - Westshire Manor</p>
            <p className='text-sm my-4'>By: Westshire Manor</p>

            <p className='font-semibold'>Stage: Building</p>
            <p className='my-5'>Project Description: Encourage participation in community service and volunteer programs
             to promote a sense of unity and address social issues. This will not only help address specific 
             problems within the community. </p>

             <div className='flex my-5 space-x-12'>
                 <button>
                    <GoHeartFill className='text-red-600 inline text-2xl mr-1' />45
                </button>
                <button>
                    <MdRemoveRedEye className='text-blue-600 inline text-2xl mr-1' />12
                </button>
             </div>
        </div>
        </Link>

      </div>
            )
        })}
    </div>



        </div>
    </div>
  )
}

export default MainProjectFeed
